import { render, staticRenderFns } from "./ModalCompletedTaskList.vue?vue&type=template&id=15a0a9d6&scoped=true&"
import script from "./ModalCompletedTaskList.vue?vue&type=script&lang=js&"
export * from "./ModalCompletedTaskList.vue?vue&type=script&lang=js&"
import style0 from "./ModalCompletedTaskList.vue?vue&type=style&index=0&id=15a0a9d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a0a9d6",
  null
  
)

export default component.exports